import { useMutation } from '@tanstack/react-query';
import { PermanentJobsService } from '../services';

export const usePostPermValuePropViewed = () => {
  return useMutation({
    mutationFn: () => PermanentJobsService.postPermValuePropViewed(),
  });
};
